import { Outlet } from 'react-router-dom';
import { Toaster } from '@ponzinomics/ui';
import { Sidebar } from './sidebar';

export function DashboardLayout(): React.ReactElement {
  return (
    <div className="flex h-screen bg-gray-950">
      <Sidebar />
      <main className="flex-1 overflow-auto">
        <div className="mx-auto max-w-6xl px-8 pb-12 pt-16">
          <Outlet />
        </div>
      </main>
      <Toaster />
    </div>
  );
}
